export default __webpack_public_path__ + "static/media/irish-briefing-smsp-gp.b96524d4.jpg";